// extracted by mini-css-extract-plugin
export default {"attribute":"SimpleAttributeRow_attribute__8XWhX","label":"SimpleAttributeRow_label__efhDN","content":"SimpleAttributeRow_content__Iz4AS"};